import type { BreakdownMode } from "./types";

/** Coerce API / form values to a valid BreakdownMode; default billingSchedule. */
export const resolveBreakdownMode = (value?: string | null): BreakdownMode =>
  value === "paymentSchedule" || value === "billingSchedule" ? value : "billingSchedule";
